/**
 * ABNManipulativeBoard - Mesa de Trabajo Manipulativa Digital (Palillos y Regletas ABN)
 * Inspirado en Matific / Aprendizaje Multisensorial NEE y 1º de Primaria
 */

export class ABNManipulativeBoardManager {
    constructor() {
        this.tens = 0;
        this.units = 0;
    }

    /**
     * Renderiza la bandeja manipulativa táctil dentro del elemento indicado
     * @param {string} containerId 
     */
    render(containerId) {
        const container = document.getElementById(containerId);
        if (!container) return;

        container.innerHTML = `
            <div class="abn-manipulative-tray" style="background: #f8fafc; border: 2px dashed #94a3b8; border-radius: 16px; padding: 15px; margin: 15px 0; touch-action: manipulation;">
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                    <h4 style="margin: 0; color: #334155; font-size: 1rem; display: flex; align-items: center; gap: 8px;">
                        🧮 <span>Mesa Manipulativa ABN</span>
                    </h4>
                    <div style="display: flex; gap: 8px;">
                        <button type="button" class="touch-accessible-btn" onclick="ABNManipulativeBoard.addUnit()" style="background: #3b82f6; color: white; border: none; border-radius: 8px; font-weight: bold; cursor: pointer;">
                            +1 Palillo
                        </button>
                        <button type="button" class="touch-accessible-btn" onclick="ABNManipulativeBoard.addTen()" style="background: #10b981; color: white; border: none; border-radius: 8px; font-weight: bold; cursor: pointer;">
                            +1 Goma (10)
                        </button>
                        <button type="button" class="touch-accessible-btn" onclick="ABNManipulativeBoard.reset()" style="background: #ef4444; color: white; border: none; border-radius: 8px; font-weight: bold; cursor: pointer;">
                            🗑️
                        </button>
                    </div>
                </div>

                <div style="display: flex; gap: 20px; min-height: 100px; background: #ffffff; border-radius: 12px; padding: 12px; border: 1px solid #e2e8f0; align-items: center;">
                    <!-- Zona Decenas (Gomas de 10) -->
                    <div style="flex: 1; border-right: 1px dashed #cbd5e1; padding-right: 10px;">
                        <span style="font-size: 0.8rem; font-weight: bold; color: #059669; display: block; margin-bottom: 6px;">
                            DECENAS (GOMAS DE 10): <span id="abnTensCount">0</span>
                        </span>
                        <div id="abnTensVisual" style="display: flex; flex-wrap: wrap; gap: 6px; min-height: 40px;"></div>
                    </div>

                    <!-- Zona Unidades (Palillos sueltos) -->
                    <div style="flex: 1; padding-left: 10px;">
                        <span style="font-size: 0.8rem; font-weight: bold; color: #2563eb; display: block; margin-bottom: 6px;">
                            UNIDADES (PALILLOS): <span id="abnUnitsCount">0</span>
                        </span>
                        <div id="abnUnitsVisual" style="display: flex; flex-wrap: wrap; gap: 4px; min-height: 40px;"></div>
                    </div>
                </div>
            </div>
        `;

        this.updateVisuals();
    }

    addUnit() {
        this.units++;
        if (this.units >= 10) {
            this.units -= 10;
            this.tens++;
            if (window.HapticsService) window.HapticsService.notification('success');
            if (window.DetectiveMentor) window.DetectiveMentor.speak('¡Fantástico! 10 palillos se han atado formando 1 goma de decena.', 'success');
        } else {
            if (window.HapticsService) window.HapticsService.selection();
        }
        this.updateVisuals();
    }

    addTen() {
        this.tens++;
        if (window.HapticsService) window.HapticsService.selection();
        this.updateVisuals();
    }

    reset() {
        this.tens = 0;
        this.units = 0;
        if (window.HapticsService) window.HapticsService.impact('medium');
        this.updateVisuals();
    }

    updateVisuals() {
        const tensCountEl = document.getElementById('abnTensCount');
        const unitsCountEl = document.getElementById('abnUnitsCount');
        const tensVisualEl = document.getElementById('abnTensVisual');
        const unitsVisualEl = document.getElementById('abnUnitsVisual');

        if (tensCountEl) tensCountEl.textContent = this.tens;
        if (unitsCountEl) unitsCountEl.textContent = this.units;

        if (tensVisualEl) {
            tensVisualEl.innerHTML = Array(this.tens).fill(0).map(() => `
                <div style="background: #10b981; color: white; padding: 4px 8px; border-radius: 6px; font-weight: bold; font-size: 0.85rem; display: inline-flex; align-items: center; gap: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                    📦 10
                </div>
            `).join('');
        }

        if (unitsVisualEl) {
            unitsVisualEl.innerHTML = Array(this.units).fill(0).map(() => `
                <div style="background: #3b82f6; color: white; width: 22px; height: 28px; border-radius: 4px; font-weight: bold; font-size: 0.8rem; display: inline-flex; align-items: center; justify-content: center; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                    🥢
                </div>
            `).join('');
        }
    }
}

export const ABNManipulativeBoard = new ABNManipulativeBoardManager();

if (typeof window !== 'undefined') {
    window.Detectimaticas = window.Detectimaticas || {};
    window.Detectimaticas.ABNManipulativeBoard = ABNManipulativeBoard;
    window.ABNManipulativeBoard = ABNManipulativeBoard;
}
